const paramBuilders = {
  simple(param, value) {
    return `${param}=${encodeURIComponent(value)}`;
  },
  array(param, value) {
    return `${param}[]=${encodeURIComponent(value)}`;
  },
};

const buildFormData = function(data = {}) {
  return Object.entries(data)
    .reduce((body, [name, value]) => {
      if (typeof value === 'undefined') {
        return body;
      }

      if (Array.isArray(value)) {
        value.forEach((v) => body.append(name, v));
      } else {
        body.append(name, value);
      }

      return body;
    }, new FormData());
};

const buildGetParams = function(params = {}) {
  return Object.entries(params)
    .filter((entry) => !!entry[1])
    .flatMap(([param, value]) => {
      if (Array.isArray(value)) {
        return value.map((val) => paramBuilders.array(param, val));
      }

      return paramBuilders.simple(param, value);
    })
    .join('&');
};

const parseSearchParams = function(search) {
  const searchParams = new URLSearchParams(search);

  const entries = Array.from(searchParams.entries());

  return Object.fromEntries(entries);
};

const parseUrlHost = function(url) {
  return new URL(url).host;
};

const buildPathUrl = function(path, base) {
  return new URL(path, base).href;
};

export {
  buildFormData,
  buildGetParams,
  parseSearchParams,
  parseUrlHost,
  buildPathUrl,
};
